// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import * as React from "react";
import {
  Grid,
  Link,
  Table,
  TableBody,
  TableContainer,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";

function Contact(props) {
  const theme = useTheme();
  const firstCellColor =
    props.firstCellColor !== undefined
      ? props.firstCellColor
      : theme.palette.text.primary;
  const StyledTableRow = styled(TableRow)({});

  const StyledFirstTableCell = styled(TableCell)(({ theme }) => ({
    padding: "0px",
    border: "none",
    width: "150px",
    color: firstCellColor,
  }));

  const StyledSecondTableCell = styled(TableCell)(({ theme }) => ({
    padding: "0px",
    paddingLeft: "16px",
    border: "none",
    color: theme.palette.primary.main,
  }));

  return (
    <Grid item>
      <Typography variant="h6">
        Freiwillige Feuerwehr Großrust-Merking
      </Typography>
      <Typography
        variant="body1"
        my={2}>
        Schulgasse&nbsp;11
        <br />
        3123&nbsp;Großrust
        <br />
        Niederösterreich
      </Typography>
      <TableContainer>
        <Table>
          <TableBody>
            <StyledTableRow>
              <StyledFirstTableCell>Mail:</StyledFirstTableCell>
              <StyledSecondTableCell>
                <Link href="mailto:grossrust-merking@feuerwehr.gv.at">
                  grossrust-merking@feuerwehr.gv.at
                </Link>
              </StyledSecondTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledFirstTableCell>Telefon:</StyledFirstTableCell>
              <StyledSecondTableCell>+43 664 8772558</StyledSecondTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledFirstTableCell>Kommandant:</StyledFirstTableCell>
              <StyledSecondTableCell>OBI Bernhard Wendl</StyledSecondTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledFirstTableCell>Kommandant-Stv:</StyledFirstTableCell>
              <StyledSecondTableCell>BI Michael Burger</StyledSecondTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledFirstTableCell>
                Leiter der Verwaltung:
              </StyledFirstTableCell>
              <StyledSecondTableCell>
                V Manfred Redlinghofer
              </StyledSecondTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
}

export default Contact;
